import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Flex, Spin } from 'antd';
import withGuard from 'components/withGuard';
import React, { useEffect, useState } from 'react';
import { Routes, useNavigate, useParams } from 'react-router';
import { Route } from 'react-router-dom';
import { getCompany } from 'api/companies';
import { getData } from 'utils';
import { captureException } from 'utils/errors';
import Layout from 'components/Layout';
import { App } from 'antd';
import Container from './Container';
import OverviewTab from './OverviewTab';
import ActivityTab from './ActivityTab';

const ROUTES = [
  { path: '', Component: OverviewTab, key: 1 },
  { path: 'activity', Component: ActivityTab, key: 2 },
];

function CompanyDetail() {
  const [company, setCompany] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const { message } = App.useApp();

  useEffect(() => {
    if (!id) return;
    setCompany(null);
    getCompany(id)
      .then((res) => {
        const data = getData(res)?.data ?? getData(res) ?? res?.data ?? res;
        setCompany(data);
      })
      .catch((e) => {
        captureException(e);
        message.error('Company not found');
        navigate('/console/customers');
      });
  }, [id, message, navigate]);

  if (!company) {
    return (
      <Layout header={<Layout.Header title="Company" />}>
        <Flex justify="center" align="center" className="h-[50vh]">
          <Spin size="large" />
        </Flex>
      </Layout>
    );
  }

  return (
    <Layout
      header={(
        <Layout.Header
          title={(
            <span>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate('/console/customers')}
                style={{ marginRight: 8 }}
              />
              {company.name || 'Company'}
            </span>
          )}
        />
      )}
    >
      <Routes>
        <Route path="*" element={<Container />}>
          <Route index element={<OverviewTab company={company} setCompany={setCompany} />} />
          <Route path="activity" element={<ActivityTab company={company} />} />
        </Route>
      </Routes>
    </Layout>
  );
}

export default withGuard(CompanyDetail, null, { redirect: true });
